import * as React from "react";

export default () => {
  return <div>Avgifter</div>;
};
